<div class="job-crops-page">
  <div class="job-crops-title-bar">
    <button type="button" class="back-btn header-btn" (click)="onBackToJobs()">← Back to Jobs</button>
    <div class="title">Select And Adjust Crops</div>
    <div class="header-right">
      <button type="button" class="next-btn header-btn" [disabled]="isSavingCrops" (click)="onNext()">
        {{ isSavingCrops ? 'Saving...' : 'Next' }}
      </button>
    </div>
  </div>

  <div class="job-crops-wrapper">
    @if (isLoading) {
    <div class="empty-state">Loading crop options...</div>
    } @else {
    <div class="crops-card">
      <div class="options-grid">
        @for (option of visibleCropOptions; track option.id) {
        <div class="option-column">
          <div class="option-title">{{ option.title }}</div>

          <div class="option-preview" #previewContainer [class.selected]="option.selected" (wheel)="onWheel($event, option)"
            (mousedown)="startImageDrag($event, option)" [style.height.px]="previewHeight">
            <img [src]="option.imagePath" [alt]="option.title" [ngStyle]="getImageStyle(option)"
              (load)="onImageLoad($event, option)" draggable="false" />

            <div class="fixed-crop-window" [style.left.px]="fixedCropRect.x" [style.top.px]="fixedCropRect.y"
              [style.width.px]="fixedCropRect.width" [style.height.px]="fixedCropRect.height">
              <div class="fixed-corner top-left"></div>
              <div class="fixed-corner top-right"></div>
              <div class="fixed-corner bottom-left"></div>
              <div class="fixed-corner bottom-right"></div>
            </div>

            <div class="crop-mask top" [style.height.px]="fixedCropRect.y"></div>
            <div class="crop-mask left" [style.top.px]="fixedCropRect.y" [style.width.px]="fixedCropRect.x" [style.height.px]="fixedCropRect.height"></div>
            <div class="crop-mask right" [style.top.px]="fixedCropRect.y" [style.width.px]="previewWidth - fixedCropRect.x - fixedCropRect.width" [style.height.px]="fixedCropRect.height"></div>
            <div class="crop-mask bottom" [style.top.px]="fixedCropRect.y + fixedCropRect.height" [style.height.px]="previewHeight - fixedCropRect.height - fixedCropRect.y"></div>
          </div>

          <div class="zoom-slider-container">
            <button type="button" class="zoom-step-btn" (click)="stepZoom(option, -0.1)" title="Zoom Out" aria-label="Zoom Out">−</button>
            <input
              type="range"
              class="zoom-slider"
              [min]="option.minUserScale"
              [max]="option.maxUserScale"
              step="0.01"
              [value]="option.userScale"
              (input)="onZoomSliderChange($event, option)"
              aria-label="Zoom Level"
            />
            <button type="button" class="zoom-step-btn" (click)="stepZoom(option, 0.1)" title="Zoom In" aria-label="Zoom In">+</button>
          </div>

          <button type="button" class="select-btn" [class.active]="option.selected" (click)="toggleSelection(option)">
            {{ option.selected ? 'Confirmed' : 'Confirm' }}
          </button>
        </div>
        }
      </div>

      <div class="hint-text">
        Zoom image with mouse wheel or slider, and drag image to position it inside the fixed crop frame, then press Confirm.
      </div>

      <div class="warning-box">
        <div class="warning-title">
          IMPORTANT! If you request a crop but there is no supplied image that has the content the crop requires, the
          crop will be ignored.
        </div>
        <div class="warning-text">
          ie: you ask for a Three-quarter crop, but all supplied images were photographed too tight in the camera.
        </div>
      </div>

      <div class="selected-label central-selected">
        Selected: <strong>{{ selectedCount }}</strong>
      </div>
    </div>


    }

    @if (errorMessage) {
    <div class="empty-state error mt-16">{{ errorMessage }}</div>
    }
  </div>

  @if (showNoCropAlert) {
  <div class="modal-overlay" (click)="showNoCropAlert = false">
    <div class="result-modal" (click)="$event.stopPropagation()">
      <div class="alert-icon">⚠️</div>
      <h3>Missing Confirmations</h3>
      <p>Please confirm all {{ visibleCropCount }} crop option(s) before proceeding to the next step.</p>
      <button type="button" class="ok-btn" (click)="showNoCropAlert = false">Got It</button>
    </div>
  </div>
  }

</div>